var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m28.7 27.3-6.25-6.27a11.01 11.01 0 1 0-1.41 1.42l6.25 6.26a1 1 0 1 0 1.42-1.42ZM5 14a9 9 0 1 1 18 0 9 9 0 0 1-18 0Z"}));
}

Search.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Search;

Search.default = Search;
